import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getVesEventsDropdownValues } from '@api/vesEvents';

import { optionsFormattedBySystemId, optionsFormattedWithArray, optionsFormattedWithIdName } from '@utils/formatter';

import { IAlarmFilter } from '@interfaces/alarms/alarm';
import { IVesEventsDropdownsDataDTO } from '@interfaces/vesData/dto/vesEventsDTO';

import { VES_EVENTS_DROPDOWN_VALUES } from '@constants/queryKeys';

interface IVesEventsDropdownValuesReturnType {
	vesEventsDropdownValues: IVesEventsDropdownsDataDTO | null;
	isLoadingVesEventsDropdownValues: boolean;
	vesEventsFilters: IAlarmFilter[];
}

export const useQueryVesEventsDropdownValues = (): IVesEventsDropdownValuesReturnType => {
	const {
		accessPermission: {
			smoLightUpdater,
			smoLightViewer,
		},
	} = useAppSelector(auth);

	const isSMOLightAccess = smoLightUpdater || smoLightViewer;

	const { data, isFetching, isLoading } = useQuery({
		queryKey: [VES_EVENTS_DROPDOWN_VALUES],
		queryFn: getVesEventsDropdownValues,
		enabled: [isSMOLightAccess],
	});

	const {
		networkElements,
		middlewares,
		sources,
	} = data || {};

	const filters = [
		{
			name: 'networkElementId',
			placeholder: 'Network Element',
			data: networkElements ? optionsFormattedWithIdName(networkElements) : [],
		},
		{
			name: 'middlewareId',
			placeholder: 'Middleware',
			data: middlewares ? optionsFormattedBySystemId(middlewares) : [],
		},
		{
			name: 'source',
			placeholder: 'Source',
			data: sources ? optionsFormattedWithArray(sources) : [],
		},
	];

	return {
		vesEventsDropdownValues: data || null,
		vesEventsFilters: filters,
		isLoadingVesEventsDropdownValues: isLoading || isFetching,
	};
};
